<template>
  <b-sidebar
    id="add-new-type-sidebar"
    :visible="isAddNewTypeSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetTypeData"
    @change="(val) => $emit('update:is-add-new-type-sidebar-active', val)"
  >

    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Add New Type')}}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner
            :animation-duration="1000"
            :size="100"
            :color="'#0e96b1'"
        />
      </div>

      <!-- BODY -->
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="onSubmit">

          <!-- Name ar -->
            <b-form-group :label="$t('Name')" label-for="name">
              <b-form-input
                id="ar_name"
                v-model="typeData.name"
                autofocus
                :state="errors && ('name' in errors) ? false : null"
                trim
                autocomplete="off"
                placeholder=""
              />

              <b-form-invalid-feedback v-if="errors && ('name' in errors)" :state="errors && ('name' in errors) ? false : null">
                {{ errors.name[0]  }}
              </b-form-invalid-feedback>

            </b-form-group>


          <!-- category -->
            <b-form-group
              :label="$t('Category')"
              label-for="category"
              :state="null"
            >
              <v-select
                v-model="typeData.category"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="categoriesOptions"
                input-id="category"
              />
              <b-form-invalid-feedback v-if="errors && ('category' in errors)" :state="errors && ('category' in errors) ? false : null">
                {{   errors.category[0]  }}
              </b-form-invalid-feedback>
            </b-form-group>



          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit">
              {{ $t('Save')}}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="resetTypeData">
              {{ $t('Reset') }}
            </b-button>
          </div>
        </b-form>

    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
  BFormTextarea
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    OrbitSpinner,

    flatPickr,

  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewTypeSidebarActive',
    event: 'update:is-add-new-type-sidebar-active',
  },
  props: {
    isAddNewTypeSidebarActive: {
      type: Boolean,
      required: true,
    },

    categoriesOptions: {
      required: true,
    },

  },
  setup(props, { emit }) {

    const blankTypeData = {
      name: '',
      category: ''
    }


    const errors = ref(null)

    const requestStatus = ref(false)

    const typeData = ref(JSON.parse(JSON.stringify(blankTypeData)))
    const resetTypeData = () => {
      typeData.value = JSON.parse(JSON.stringify(blankTypeData))
    }

    const onSubmit = () => {

      requestStatus.value = true
      errors.value = null

      store.dispatch('app-type/addType', typeData.value)
        .then(() => {
          requestStatus.value = false
          emit('refetch-data')
          emit('update:is-add-new-type-sidebar-active', false)
        }).catch(res => {
          requestStatus.value = false
          if (res.response.status === 422) {
            errors.value = res.response.data.errors}
           console.log(res.response.data)

          }
      )
    }


    return {
      typeData,
      onSubmit,
      resetTypeData,
      requestStatus,
      errors
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-new-type-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
